const it = {
  translation: {
    yes: "SI",
    no: "NO",
    loading: "Caricamento",
    email: "Email",
    password: "Password",
    "select-all": "Seleziona tutto",
    clear: "Cancella filtro",
    close: "Chiudi",
    confirm: "Conferma",
    cancel: "Annulla",
    "clear-filter": "Annulla filtro",
    "clear-all-filters": "Cancella filtri",
    from: "Da",
    to: "A",
    "date.placeholder": "gg.mm.aaaa",
    save: "Salva",
    add: "Aggiungi",
    Validate: "Valida",
    Validating: "Validazione",
    disabling: "Disabilitazione",
    apply: "Applica",
    "reset-all": "Reimposta tutto",
    insert_value: "Inserisci un valore",
    revert: "Ripristina",
    delete: "Elimina",
    actions: "Azioni",
    history: "Archivio",
    "h304.warning":
      "Attenzione H304 trovata! Verificare la viscosità cinematica",
    "hazard.warning":
      "Attenzione H304 trovata! Verificare la viscosità cinematica",

    "theme.set-dark": "Imposta modalità scura",
    "theme.set-light": "Imposta modalità chiara",

    "language.tooltip": "Imposta lingua",

    "auth.login.button": "Accedi",
    "auth.logout.button": "Disconnetti",
    "auth.login.error": "Impossibile accedere. Riprova più tardi",
    "auth.login.wrongEmail": "Email errata",
    "auth.login.invalidCredentials": "Credenziali non valide",
    "auth.validation.email.invalid": "Questa email non è valida!",
    "auth.validation.email.required": "Email obbligatoria!",
    "auth.validation.password.required": "Password obbligatoria!",
    "auth.validation.password.tooShort":
      "La password deve contenere almeno 8 caratteri",
    "auth.validation.password.requirements":
      "La password deve contenere almeno una lettera maiuscola, una lettera minuscola, un numero e un carattere speciale",
    "auth.validation.password.match": "Le password devono corrispondere",
    "auth.validation.password.confirmRequired": "Conferma la tua password",
    "auth.login.title": "Intelligenza Automatizzata per SDS",
    "auth.login.slogan": "Automazione Dati SDS con IA",
    "auth.login.subtitle": "Inserisci i dettagli del tuo account",
    "auth.login.scanning": "Scansione documenti...",
    "auth.login.dataExtracted": "Dati estratti con successo",
    "auth.login.noAccount": "Non hai ancora un account?",
    "auth.login.signUp": "Registrati",
    "auth.acceptInvite.title": "Benvenuto in HSE Genius",
    "auth.acceptInvite.subtitle":
      "Crea una password per attivare il tuo account",
    "auth.acceptInvite.password": "Crea Password",
    "auth.acceptInvite.confirmPassword": "Conferma Password",
    "auth.acceptInvite.submit": "Attiva Account",
    "auth.acceptInvite.success":
      "Il tuo account è stato attivato con successo! Sarai reindirizzato alla pagina di login.",
    "auth.acceptInvite.error":
      "Si è verificato un errore durante l'attivazione del tuo account. Riprova o contatta l'assistenza.",
    "auth.acceptInvite.missingParams":
      "Link di invito non valido. Controlla la tua email e riprova.",
    "auth.acceptInvite.missingToken":
      "Token non valido. Controlla la tua email e riprova.",
    "auth.signup.firstName": "Nome",
    "auth.signup.lastName": "Cognome",
    "auth.signup.emailLabel": "Email aziendale",
    "auth.signup.emailHint": "Usa la tua email aziendale (es. nome@tuaazienda.it)",
    "auth.signup.passwordLabel": "Password",
    "auth.signup.req.len": "8+ caratteri",
    "auth.signup.req.upper": "Maiuscola",
    "auth.signup.req.digit": "Numero",
    "auth.signup.req.special": "Carattere speciale",
    "auth.signup.termsPrefix": "Accetto i",
    "auth.signup.termsLink": "Termini e Condizioni",
    "auth.signup.termsAnd": "e la",
    "auth.signup.privacyLink": "Privacy Policy",
    "auth.signup.firstNameRequired": "Inserisci il tuo nome",
    "auth.signup.firstNameMax": "Massimo 50 caratteri",
    "auth.signup.lastNameRequired": "Inserisci il tuo cognome",
    "auth.signup.lastNameMax": "Massimo 50 caratteri",
    "auth.signup.phoneInvalid": "Solo cifre, spazi e trattini (il prefisso va nel menu a sinistra)",
    "auth.signup.phoneMax": "Massimo 10 cifre",
    "auth.signup.emailInvalid": "Inserisci un'email valida",
    "auth.signup.emailRequired": "Inserisci la tua email",
    "auth.signup.passwordMin": "Minimo 8 caratteri",
    "auth.signup.passwordUppercase": "Aggiungi una lettera maiuscola",
    "auth.signup.passwordDigit": "Aggiungi un numero",
    "auth.signup.passwordSpecial": "Aggiungi un carattere speciale (es. !@#$%)",
    "auth.signup.passwordRequired": "Scegli una password",
    "auth.signup.accountCreated": "Perfetto! Controlla la tua email per il codice di attivazione.",
    "auth.signup.errorGeneric": "Problema di connessione. Riprova tra un momento.",
    "auth.signup.title": "Inizia gratis — 50 crediti",
    "auth.signup.activateTitle": "Attiva il tuo account",
    "auth.signup.welcome":
      "Registrati con la tua azienda e ricevi subito 50 crediti per provare HSE Genius.",
    "auth.signup.phone": "Telefono (opzionale)",
    "auth.signup.submit": "Crea account gratuito",
    "auth.signup.submitting": "Creazione account...",
    "auth.signup.emailNotice": "Riceverai un codice di verifica via email per attivare l'account.",
    "auth.signup.hasAccount": "Hai già un account?",
    "auth.signup.signIn": "Accedi",
    "auth.signup.typeCompany": "Azienda",
    "auth.signup.typeConsultant": "Consulente HSE",
    "auth.signup.emailLabelConsultant": "Email",
    "auth.signup.emailHintConsultant": "Usa la tua email personale o professionale",
    "auth.signup.phoneRequired": "Telefono *",
    "auth.signup.phoneRequiredError": "Inserisci il tuo numero di telefono",
    "auth.signup.partitaIva": "Partita IVA (opzionale)",
    "auth.signup.pendingTitle": "Email verificata!",
    "auth.signup.pendingMessage": "Il tuo account consulente è in revisione dal team HSE Genius. Riceverai una email appena sarà attivato — di solito entro 24h.",
    "auth.signup.goToLogin": "Vai al Login",
    "auth.signup.activatedTitle": "Account attivato!",
    "auth.signup.activatedMessage": "Accesso in corso...",
    "auth.signup.otpTitle": "Quasi fatto!",
    "auth.signup.otpMessage": "Inserisci il codice a 6 cifre che ti abbiamo inviato via email.",
    "auth.signup.activating": "Attivazione in corso...",
    "auth.signup.activateBtn": "Attiva account",
    "auth.signup.resendCode": "Invia un nuovo codice",
    "auth.signup.trust1": "✓ Nessuna carta di credito",
    "auth.signup.trust2": "✓ Attivo in 2 minuti",
    "auth.signup.trust3": "✓ 50 crediti gratuiti",
    "auth.signup.resendActivation": "Reinvia Email di Attivazione",
    "auth.signup.backToSignup": "Torna alla registrazione",
    "auth.signup.checkEmail": "Controlla la tua email per le istruzioni di attivazione.",
    "auth.signup.loginAfterActivation": "Attivazione completata! Accedi per continuare.",
    "auth.signup.activationError": "Controlla il codice e riprova.",
    "auth.signup.resendDialog.title": "Invia un nuovo codice",
    "auth.signup.resendDialog.message": "Ti inviamo un nuovo codice di attivazione a",
    "auth.signup.resendDialog.sending": "Invio in corso...",
    "auth.signup.resendDialog.confirm": "Invia",
    "auth.common.6digits":
      "Inserisci il codice a 6 cifre che ti abbiamo inviato via email.",
    "auth.common.resendCode": "Invia nuovamente il codice",
    "auth.common.signInBack": "Torna al login",
    "auth.common.verifyCode": "Verifica il codice",
    "auth.resetPassword.title": "Reimposta Password",
    "auth.resetPassword.subtitle":
      "Inserisci la tua email e ti invieremo un codice di reset",
    "auth.resetPassword.emailSent":
      "Se esiste un account con questa email, è stata inviata una email di reset",
    "auth.resetPassword.newPassword": "Nuova Password",
    "auth.resetPassword.confirmPassword": "Conferma Password",
    "auth.resetPassword.token": "Token di Reset",
    "auth.resetPassword.success":
      "Password reimpostata con successo! Reindirizzamento al login...",
    "auth.login.forgotPassword": "Password dimenticata?",
    "auth.resetPassword.support":
      "Se riscontri un errore, inviaci una email al nostro supporto",
    "auth.resetPassword.supportLink": "supporto",
    "auth.mfa.title": "Autenticazione a due fattori",
    "auth.mfa.subtitle": "Apri la tua app di autenticazione (Google Authenticator, Authy, ecc.) e inserisci il codice a 6 cifre per HSE Genius.",
    "auth.mfa.codeLabel": "Codice a 6 cifre",
    "auth.mfa.verify": "Verifica",
    "auth.mfa.error.sessionExpired": "La sessione di verifica MFA è scaduta. Accedi nuovamente.",
    "auth.mfa.error.codeLength": "Inserisci il codice a 6 cifre dalla tua app di autenticazione.",
    "auth.mfa.error.invalidCode": "Codice non valido. Riprova.",
    "welcome.greeting": "Ciao, {{name}}!",
    "welcome.today": "Oggi è",
    "welcome.stat.imported": "SDS importate",
    "welcome.stat.validated": "SDS validate",
    "welcome.stat.archive": "Archivio",
    "welcome.enter": "Entra",
    "profile.edit.button": "Modifica profilo",
    "profile.title": "Profilo",
    "profile.first-name.required": "Nome richiesto",
    "profile.last-name.required": "Cognome richiesto",
    "profile.phone.required": "Telefono richiesto",
    "profile.email.invalid-format": "Formato email non valido",
    "profile.email.required": "Email richiesta",
    "profile.password.required": "Password richiesta",
    "profile.password-mismatch": "Le password non corrispondono",

    "first-name": "Nome",
    "last-name": "Cognome",
    "phone-number": "Numero di telefono",
    "password-confirm": "Conferma Password",
    "edit-profile.title": "Modifica Profilo",
    "edit-profile.change-password": "Cambia Password",
    "edit-profile.success": "Profilo aggiornato con successo",

    "uploading-files.title": "Carica",
    "uploading-files.upload.error":
      "Si è verificato un errore durante il caricamento del file!",
    "uploading-files.dropzone.text.1": "Importa le ",
    "uploading-files.dropzone.text.2": "Schede di Sicurezza",
    "uploading-files.dropzone.text.3": " da caricare",
    "uploading-files.dropzone.text.active": "Rilascia qui",
    "uploading-files.uploaded-files": "SDS da elaborare",
    "uploading-files.sds-to-import": "SDS da importare",
    "uploading-files.uploading-pdf": "Caricamento PDF in corso...",
    "uploading-files.imported-count": "Nuove schede importate",
    "upload-files.get.error": "Errore nel caricamento dei file",
    "upload-files.delete.error": "Errore nell'eliminazione del file",
    "upload-files.confirm": "Elabora",
    "upload-files.confirm.error": "Errore nella conferma dei file caricati",
    "ai-processing.scanning": "Scansione PDF...",
    "ai-processing.extracting": "Estrazione dati...",
    "ai-processing.structuring": "Strutturazione informazioni...",
    "ai-processing.organizing": "Organizzazione tabella...",

    "parsed-files.title": "Importate",
    "parsed-files.proceed": "Finalizza",
    "parsed-files.send-email.button": "Invia report via email",
    "parsed-files.send-email.success":
      "Grazie per aver utilizzato HSE Genius!\nL’operazione è stata completata con successo.\nUn riepilogo è stato inviato via email.",

    "parsed-files.table.title": "Nome tabella",
    "parsed-files.table.subtitle": "Qui va un testo descrittivo",
    "parsed-files.send-email": "Invia Email",
    "parsed-files.send-email.success-brief": "Email inviata con successo",
    "parsed-files.send-email.error":
      "Si è verificato un errore durante l'invio dell'email!",
    "parsed-files.export": "Esporta",
    "parsed-files.export.success": "Dati esportati con successo",
    "parsed-files.export.error":
      "Si è verificato un errore durante l'esportazione dei dati!",
    "parsed-files.update.error":
      "Si è verificato un errore durante la modifica dei dati del file!",
    "parsed-files.get.error":
      "Si è verificato un errore durante il caricamento dei dati!",
    "parsed-files.invalid-concentration":
      "Concentrazione non valida: correggi le celle evidenziate e riprova.",
    "parsed-files.proceed.success": "Dati elaborati con successo",
    "parsed-files.proceed.error":
      "Si è verificato un errore durante l'elaborazione dei dati!",
    "parsed-files.create.title": "Aggiungi nuovo record",
    "parsed-files.create.error":
      "Si è verificato un errore durante la creazione del record!",
    "parsed-files.delete.error":
      "Si è verificato un errore durante l'eliminazione del record!",
    "parsed-files.disabling": "Disabilitazione",
    "parsed-files.validating": "Validazione",
    "parsed-files.valid.title": "Valida",
    "parsed-files.fullscreen": "Schermo intero",
    "parsed-files.fullscreen-exit": "Esci da schermo intero",
    "parsed-files.fullscreen-menu": "Menu",
    "parsed-files.history.customer-not-found": "Cliente non trovato",
    "parsed-files.history.customer-not-found-description":
      "Per favore crea un nuovo cliente o seleziona uno esistente.",
    "parsed-files.history.customer-not-found-error":
      "Cliente non trovato. Per favore crea un nuovo cliente o seleziona uno esistente.",
    "parsed-files.history.search-customer": "Cerca cliente",
    "parsed-files.history.not-assigned": "Non assegnato",
    "parsed-files.history.search-by-name-or-vat":
      "Cerca per nome o partita IVA",
    "parsed-files.history.duplicate-to-parsed": "Duplica in Importate",
    "parsed-files.history.move-to-parsed": "Sposta in Importate",
    "parsed-files.history.duplicate-success": "Record duplicato in Importate.",
    "parsed-files.history.move-success": "Record spostati in Importate.",

    "parsed-table.eer_codes": "codici eer",
    "parsed-table.nome_file": "nome file",
    "parsed-table.ghs": "GHS",
    "parsed-table.numero_onu": "numero onu",
    "parsed-table.classe": "classe",
    "parsed-table.data_di_revisione": "data di revisione",
    "parsed-table.gruppo_di_imballaggio": "gruppo di imballaggio",
    "parsed-table.h_punto_2": "H 2.1 and EUH 2",
    "parsed-table.precautionary_statements": "frasi P",
    "parsed-table.h_punto_3": "H/EUH 3",
    "parsed-table.h_echa_harmonized_classification":
      "H ECHA Classificazione Armonizzata",
    "parsed-table.nome_del_prodotto": "nome del prodotto",
    "parsed-table.cod_art": "cod. art.",
    "parsed-table.produttore": "produttore",
    "parsed-table.zdhc": "Zdhc",
    "parsed-table.pericoloso_per_lambiente": "pericoloso per l'ambiente",
    "parsed-table.stato_fisico": "stato fisico",
    "parsed-table.uso_appropriato": "uso appropriato",
    "parsed-table.actions": "azioni",
    "parsed-table.collapse-all-rows": "Comprimi tutte le righe",
    "parsed-table.expand-all-rows": "Espandi tutte le righe",
    "parsed-table.expand-row": "Espandi riga",
    "parsed-table.collapse-row": "Comprimi riga",
    "parsed-table.lock-row": "Blocca riga",
    "parsed-table.unlock-row": "Sblocca riga",
    "parsed-table.lock-table": "Blocca tabella",
    "parsed-table.unlock-table": "Sblocca tabella",
    "parsed-table.cas": "CAS/EC/REACH",
    "parsed-table.composizione_punto_3": "composizione punto 3",
    "parsed-table.concentrazione": "concentrazione",
    "parsed-table.concentration": "% di rifiuto nella SDS",
    "parsed-table.user_concentration": "% di rifiuto nella SDS",
    "parsed-table.svch": "SVHC",
    "parsed-table.allegato_xiv": "Allegato XIV",
    "parsed-table.qty_seveso": "Q.ta Seveso",
    "parsed-table.seveso": "Seveso",
    "parsed-table.seveso_code_h2": "L. Seveso H2",
    "parsed-table.seveso_code_p15": "L. Seveso P15",
    "parsed-table.seveso_match": "Match Seveso",
    "parsed-table.punto_di_ebollizione": "punto di ebollizione",
    "parsed-table.ph": "ph",
    "parsed-table.cov": "cov",
    "parsed-table.notes": "note",
    "parsed-table.sds_8_2_info": "8.2. Controlli dell`esposizione",
    "parsed-table.sds_8_2_view_details": "Vedi dettagli",
    "parsed-table.sds_8_2_technical_controls": "8.2 Controlli dell'esposizione",
    "parsed-table.sds_8_2_ppe_hands": "DPI Mani (materiale / breakthrough)",
    "parsed-table.sds_8_2_ppe_skin": "DPI Pelle",
    "parsed-table.sds_8_2_ppe_body": "DPI Corpo",
    "parsed-table.sds_8_2_ppe_hands_skin_body": "DPI Mani, pelle e corpo (paragrafi: mani, poi pelle, poi corpo)",
    "parsed-table.sds_8_2_ppe_eyes": "DPI Occhi",
    "parsed-table.sds_8_2_ppe_respiratory": "DPI Respiratorio",
    "parsed-table.sds_8_2_hygiene_other": "Note Igiene / Altro",
    "parsed-table.sds_8_2_ppe_environmental_exposure": "Controlli esposizione ambientale",
    "parsed-table.sds_8_2_ppe_complementary_emergency_measures": "Misure di emergenza complementari",
    "parsed-table.sds_8_2_ppe_thermal_risk": "Rischio termico",
    "parsed-table.status": "stato",
    "parsed-table.status_changed_at": "stato cambiato il",
    "parsed-table.history.noChanges": "Non ci sono modifiche",
    "parsed-table.history.modifications": "Modifiche",
    "parsed-table.history.before": "Prima",
    "parsed-table.history.after": "Dopo",
    "parsed-table.history.user": "Utente",
    "parsed-table.history.datetime": "Data/Ora",
    "parsed-table.history.show-icon": "Mostra icona cronologia",
    "parsed-table.username": "Username",
    "parsed-table.created_at": "Data di importazione",
    "parsed-table.customer": "cliente",

    "parsed-table.sub_total_mixture": "Sub Total Miscela",
    "parsed-table.sub_total_aggregation": "Sub Total Accorpamento",
    "parsed-table.total_mixture": "Total Miscela",
    "parsed-table.total_aggregation": "Total Accorpamento",
    "parsed-table.sub_total": "Sub Total",
    "parsed-table.total": "Total",

    "files-history.title": "Archivio",
    "files-history.empty-table": "L'archivio dei file caricati è vuoto",
    "files-history.totals": "{{count}} SDS",

    "eer-codes.label": "Seleziona codici EER",
    "eer-codes.get.error":
      "Si è verificato un errore durante il caricamento dei codici EER!",
    "eer-codes.filter": "Codici EER",
    "eer-codes.filter-singular": "codice EER",
    "eercode.update.success": "Codice EER aggiornato con successo",
    "eercode.update.error": "Errore nell'aggiornamento del codice EER",
    "eercode.remove.success": "Codice EER rimosso con successo",
    "eercode.remove.error": "Errore nella rimozione del codice EER",

    "column-manager.title": "Gestisci colonne",
    "column-manager.hint": "Trascina per riordinare, spunta per mostrare la colonna",
    "column-manager.reset": "Ripristina predefinito",

    "p-statements-catalog.title": "Riferimento frasi P",
    "p-statements-catalog.search-placeholder": "Cerca per codice P",
    "p-statements-catalog.export-csv": "Esporta CSV",
    "p-statements-catalog.export-filename": "frasi-p.csv",
    "p-statements-catalog.code": "Codice",
    "p-statements-catalog.description": "Descrizione",
    "p-statements-catalog.empty": "Nessun codice P corrispondente.",
    "p-statements-catalog.info-tooltip": "Apri catalogo completo frasi P",
    "p-statements-catalog.close": "Chiudi",

    "not-found.title": "Pagina non trovata",
    "not-found.subtitle": "La pagina che stai cercando non esiste.",

    "sub-rows.title": "Aggiungi sotto-riga",
    "sub-rows.field-required": "Questo campo è obbligatorio",
    "sub-rows.create.error": "Errore nella creazione della sotto-riga",

    "table-columns-manager.title": "Gestisci colonne",
    "table-preferences.title": "Preferenze Tabella",
    "table-preferences.light-mode": "Modalità chiara",
    "table-preferences.dark-mode": "Modalità scura",
    "table-preferences.even-color": "Colore delle righe pari",
    "table-preferences.odd-color": "Colore delle righe dispari",
    "table-preferences.selected-color": "Colore delle righe selezionate",
    "table-preferences.text-color": "Colore del testo",

    "parsed-files-validation.title": "Validazione",
    "parsed-files.validate": "Estrai HP",
    "parsed-files.validate.confirmation":
      "Vuoi aggiungere i record al codice CER esistente nella pagina di validazione?",
    "parsed-files.validate.eer-required":
      "Inserire un codice EER per tutte le righe prima di usare Estrai HP. Le righe senza codice EER non possono essere validate.",

    "parsed-files.export.no-id":
      "Non hai selezionato alcun record. Vuoi esportare tutti i record?",
    "parsed-files.proceed.no-id":
      "Non hai selezionato alcun record. Vuoi procedere con tutti i record?",
    "parsed-files.validate.no-id":
      "Non hai selezionato alcun record. Vuoi convalidare tutti i record?",
    "parsed-files.revert.no-id":
      "Non hai selezionato alcun record. Vuoi ripristinare tutti i record?",
    "parsed-files.revert.error": "Errore nel ripristino dei file",
    "parsed-files.validate.success": "Record validati.",
    "parsed-files.revert.success": "Record ripristinati in Importate.",

    "footer.note":
      "HSE GENIUS® potrebbe commettere errori. Considera di verificare le informazioni importanti.",
    "footer.instructions": "Istruzioni",

    "config.title": "Lista di controllo",
    "config.addButton": "Aggiungi",
    "config.dialog.title": "Aggiungi termine",
    "config.word": "Parola",
    "config.info": "Le parole in lista di controllo vengono usate durante l’elaborazione degli SDS: ogni occorrenza nella colonna «Composizione punto 3» viene segnalata e mostrata in rosso nella tabella dei file elaborati. Aggiungi i termini da evidenziare (es. nomi di sostanze, codici di pericolo); il confronto è indipendente da maiuscole/minuscole.",
    "config.fetch.error": "Errore nel recupero della configurazione",
    "config.add.error": "Errore nell'aggiunta della configurazione",
    "config.remove.error": "Errore nella rimozione della configurazione",

    "customers.title": "Clienti",
    "customers.export": "Esporta",
    "customers.create": "Aggiungi cliente",
    "customers.createCustomer": "Crea nuovo cliente",
    "customers.createCustomerDescription":
      "Inserisci i dettagli del nuovo cliente",
    "customers.fields.name": "Nome",
    "customers.fields.slag": "Abbreviazione",
    "customers.fields.email": "Email",
    "customers.fields.phone": "Telefono",
    "customers.fields.address": "Indirizzo",
    "customers.fields.city": "Città",
    "customers.fields.postalCode": "Codice Postale",
    "customers.fields.country": "Paese",
    "customers.fields.vat": "Partita IVA",
    "customers.errors.nameRequired": "Nome obbligatorio",
    "customers.errors.slagRequired": "Abbreviazione obbligatoria",
    "customers.errors.emailRequired": "Email obbligatoria",
    "customers.errors.emailInvalid": "Email non valida",
    "customers.errors.cityRequired": "Città obbligatoria",
    "customers.errors.postalCodeRequired": "Codice postale obbligatorio",
    "customers.errors.countryRequired": "Paese obbligatorio",
    "customers.errors.vatRequired": "Partita IVA obbligatoria",
    "customers.notifications.createSuccess": "Cliente creato con successo",
    "customers.notifications.createError": "Errore nella creazione del cliente",
    "customers.notifications.updateSuccess": "Cliente aggiornato con successo",
    "customers.notifications.updateError":
      "Errore nell'aggiornamento del cliente",
    "customers.edit.success": "Cliente modificato con successo",
    "customers.edit.error": "Errore nella modifica del cliente",
    "customers.delete.confirmation":
      "Sei sicuro di voler eliminare {{count}} cliente/i?",
    "customers.delete.success": "Cliente/i eliminato/i con successo",
    "customers.delete.error": "Errore nell'eliminazione del/i cliente/i",
    "customers.fetch.error": "Errore nel recupero dei clienti",
    "customers.noCustomers": "Nessun cliente trovato",

    "parsed-files": {
      history: {
        title: "Salva in archivio",
        description:
          "Seleziona un cliente per spostare gli elementi selezionati nell'archivio.",
        "selected-description":
          "Vuoi salvare {{count}} elementi selezionati nell'archivio?",
        "all-description": "Vuoi salvare tutti gli elementi nell'archivio?",
        step1: "Seleziona Cliente",
        step2: "Conferma",
        "select-customer": "Seleziona un cliente",
        confirm: "Sei sicuro di voler salvare questi elementi nell'archivio?",
        save: "Salva",
        success: "Elementi spostati nell'archivio con successo",
        error: "Errore durante lo spostamento degli elementi nell'archivio",
        "no-customer": "Seleziona un cliente",
        "remove-from-parsed-after": "Rimuovi SDS dalla pagina Importate dopo il salvataggio",
        notes: "Note",
        "enter-notes": "Inserisci note (opzionale)",
      },
    },

    // Company page translations
    "admin.tabs.company": "Gestione Azienda",
    "admin.tabs.subscription": "Gestione Abbonamenti",
    "admin.tabs.invites": "Inviti Utenti",
    "admin.tabs.logs": "Logs",

    // Company section
    "admin.company.title": "Dettagli Azienda",
    "admin.company.vatNumber": "Partita IVA",
    "admin.company.vatLabel": "P.IVA",
    "admin.company.companyName": "Nome Azienda",
    "admin.company.companyEmail": "Email Aziendale",
    "admin.company.phoneNumber": "Numero di Telefono",
    "admin.company.city": "Città",
    "admin.company.country": "Paese",
    "admin.company.address": "Indirizzo",
    "admin.company.postalCode": "Codice Postale",
    "admin.company.submit": "CREA",
    "admin.company.publicEmailError":
      "Per favore utilizza la tua email aziendale. I domini email pubblici non sono consentiti.",
    "admin.company.createSuccess": "Azienda creata con successo!",
    "admin.company.sdiUniqueCode": "Codice Univoco SDI",
    "admin.company.sdiUniqueCodeRequired":
      "Il Codice Univoco SDI è obbligatorio.",
    "admin.company.countryCode": "Prefisso Internazionale",
    "admin.company.countryCodeRequired":
      "Il prefisso internazionale è obbligatorio.",
    "admin.company.companyUsers": "Utenti Aziendali",
    "admin.company.contactInfo": "Informazioni di Contatto",
    "admin.company.additionalInfo": "Informazioni Aggiuntive",
    "admin.company.usersFetchError":
      "Impossibile caricare gli utenti aziendali",
    "admin.company.member": "Membro",
    "admin.company.noUsers": "Nessun utente trovato per questa azienda",
    "admin.company.userName": "Nome Utente",
    "admin.company.role": "Ruolo",
    "admin.company.actions": "Azioni",
    "admin.company.edit": "Modifica",
    "admin.company.delete": "Elimina",
    "admin.company.editRole": "Modifica Ruolo Utente",
    "admin.company.confirmDelete":
      "Sei sicuro di voler eliminare questo utente?",
    "admin.company.updateError":
      "Errore durante l'aggiornamento del ruolo utente. Riprova.",
    "admin.company.deleteError":
      "Errore durante l'eliminazione dell'utente. Riprova.",
    "admin.company.employee": "Dipendente",
    "admin.company.requestCount": "SDS Totali processate",
    "admin.company.requestLimit": "Totale SDS per la licenza attiva per mese",
    "admin.company.creditLimit": "Totale credito rimanente per SDS",
    "admin.company.createdAt": "Licenza attiva dal",
    "admin.company.expiredAt": "Scadenza Licenza il",
    "admin.company.resendInviteSuccess": "Invito reinviato con successo",
    "admin.company.premiumService": "Servizio Premium",
    "admin.company.premiumAudit": "Audit",
    "admin.company.premiumAuditHint": "Abilita la pagina Audit per l'azienda. Servizio premium.",
    "admin.company.premiumAuditUpdated": "Servizio Audit aggiornato.",
    "admin.company.premiumAuditUpdateError": "Impossibile aggiornare.",
    "admin.company.premiumAuditActive": "Attivo",
    "admin.company.premiumAuditInactive": "Disattivo",
    "admin.company.premiumAuditContactReferente": "Contatta il tuo referente HSE Genius per abilitare.",

    "admin.company.mfaRequired": "Richiedi 2FA per tutti gli utenti dell'azienda",
    "admin.company.mfaRequiredActive": "Tutti gli utenti dovranno completare la registrazione TOTP al prossimo accesso.",

    "admin.company.createdTitle": "Azienda Creata!",
    "admin.company.created":
      "Complimenti! La tua azienda è stata registrata con successo.\nAbbiamo attivato per te il Pacchetto Demo — hai 50 crediti a disposizione per provare HSE Genius.\nInizia ora e scopri tutte le funzionalità!",

    // Subscription section
    "admin.subscription.title": "Piani di Abbonamento",
    "admin.subscription.features.oneTime": "Limite di credito: {{count}}",
    "admin.subscription.features.sdsPerMonth": "{{count}} SDS al mese",
    "admin.subscription.features.sds": "{{count}} SDS",
    "admin.subscription.features.additionalSds":
      "Dopo {{count}} SDS, €{{price}} per ogni SDS aggiuntivo",
    "admin.subscription.features.dataArchive": "Archivio dati",
    "admin.subscription.features.eerHandling": "Gestione codici EER",
    "admin.subscription.features.hpCalculator": "Estrazione con calcolatore HP",
    "admin.subscription.features.aggregationCalculator":
      "Funzione speciale: calcolatore di aggregazione",
    "admin.subscription.features.blendCalculator":
      "Funzione speciale: calcolatore di miscela",
    "admin.subscription.features.prioritySupport": "Supporto prioritario",
    "admin.subscription.features.multiUserDashboard": "Dashboard multi-utente",
    "admin.subscription.perMonth": "/mese",
    "admin.subscription.selected": "Selezionato",
    "admin.subscription.select": "Seleziona",
    "admin.subscription.quantityLabel": "Acquista credito",
    "admin.subscription.activated": "Attivato",
    "admin.subscription.success.title": "Licenza Attiva!",
    "admin.subscription.success.content":
      "Grazie per aver scelto HSE Genius. La tua licenza è ora attiva e puoi iniziare subito a utilizzare tutte le funzionalità disponibili.",
    "admin.subscription.checkout": "Paga",
    "admin.subscription.paymentError": "Errore di pagamento. Riprova.",
    "admin.subscription.active": "Abbonamento Attivo",
    "admin.subscription.plan": "Piano",
    "admin.subscription.status": "Stato",
    "admin.subscription.paused": "L'abbonamento è attualmente in pausa",
    "admin.subscription.created": "Creato il",
    "admin.subscription.nextPayment": "Prossimo Pagamento",
    "admin.subscription.expires": "Scade il",
    "admin.subscription.cancelAtEnd":
      "Cancellazione automatica alla fine del periodo",
    "admin.subscription.oneTime": "{{amount}}€/pacchetto + IVA",
    "admin.subscription.annualBilling":
      "Fatturazione annuale: {{amount}}€ + IVA all'anno",
    "admin.subscription.inactive": "Inattivo",
    "admin.subscription.paymentRef": "Riferimento Pagamento",
    "admin.subscription.paymentMethod": {
      cc: "Carta di Credito",
      wire: "Bonifico",
      label: "Metodo di Pagamento",
    },
    "admin.subscription.wireTransfer": {
      title: "Dettagli Bonifico",
      firstName: "Nome",
      lastName: "Cognome",
      iban: "IBAN",
      submit: "Invia",
      required: "Tutti i campi sono obbligatori.",
    },
    "admin.subscription.createOrder": "Crea ordine",
    "admin.subscription.orderCreated":
      "Ordine creato, verifica l'email per i dettagli",
    "admin.subscription.proceed": "Procedi",
    "admin.subscription.proceedToPayment": "Procedi al Pagamento",

    // Invites section
    "admin.invites.title": "Invita Utenti",
    "admin.invites.subtitle":
      "Invia un'email di invito per collaborare al tuo progetto",
    "admin.invites.emailAddress": "Indirizzo Email",
    "admin.invites.emailPlaceholder": "collega@azienda.com",
    "admin.invites.firstName": "Nome",
    "admin.invites.lastName": "Cognome",
    "admin.invites.phone": "Numero di Telefono",
    "admin.company.active": "Attiva",
    "admin.company.waiting": "In attesa",
    "admin.invites.role": "Ruolo",
    "admin.invites.roleAdmin": "Amministratore",
    "admin.invites.roleAuditor": "Revisore",
    "admin.invites.roleEmployee": "Dipendente",
    "admin.invites.roleViewer": "Visualizzatore",
    "admin.invites.errorRequiredRole": "Il ruolo è obbligatorio",
    "admin.invites.firstNamePlaceholder": "Inserisci nome",
    "admin.invites.lastNamePlaceholder": "Inserisci cognome",
    "admin.invites.phonePlaceholder": "Inserisci numero di telefono",
    "admin.invites.sending": "Invio in corso...",
    "admin.invites.sendInvite": "Invia",
    "admin.invites.pending": "In Attesa",
    "admin.invites.accepted": "Accettato",
    "admin.invites.expired": "Scaduto",
    "admin.invites.invitedUsers": "Utenti Invitati",
    "admin.invites.resendInvite": "Reinvia Invito",
    "admin.invites.removeInvite": "Rimuovi Invito",
    "admin.invites.sentSuccess": "Invito inviato con successo!",
    "admin.invites.resendSuccess": "Invito reinviato a {{email}}",
    "admin.invites.removeSuccess": "Invito rimosso",
    "admin.invites.invitedAt": "Invitato il",
    "admin.invites.invitedOn": "Invitato il",
    "admin.invites.status": "Stato",
    "admin.invites.actions": "Azioni",
    "admin.invites.noInvites": "Nessun invito inviato",
    "admin.invites.errorRequiredEmail": "Inserisci un indirizzo email",
    "admin.invites.errorValidEmail":
      "Inserisci un indirizzo email aziendale valido",
    "admin.invites.errorValidEmailFormat": "Formato email non valido",
    "admin.invites.errorRequiredFirstName": "Il nome è obbligatorio",
    "admin.invites.errorRequiredLastName": "Il cognome è obbligatorio",
    "admin.invites.errorRequiredPhone": "Il numero di telefono è obbligatorio",
    "admin.invites.errorDuplicateEmail": "Questa email è già stata invitata",
    "admin.invites.failedInvite": "Impossibile inviare l'invito. Riprova.",
    "admin.invites.failedResend": "Impossibile reinviare l'invito",
    "admin.invites.failedRemove": "Impossibile rimuovere l'invito",

    // Logs section
    "admin.logs.title": "Logs",
    "admin.logs.subtitle": "Visualizza i logs dell'azienda",
    "admin.logs.logs": "Logs",
    "admin.logs.noLogs": "Nessun log trovato",
    "admin.logs.logsFetchError": "Impossibile caricare i logs",
    "admin.logs.logsFetchSuccess": "Logs caricati con successo",

    "admin.logs.table.id": "ID",
    "admin.logs.table.action": "Azione",
    "admin.logs.table.status": "Status",
    "admin.logs.table.documentStatus": "Status documento",
    "admin.logs.table.ip": "IP",
    "admin.logs.table.timestamp": "Timestamp",
    "admin.logs.table.user": "Utente",
    "admin.logs.table.filename": "Nome del file",
    "admin.logs.export": "Esporta",
    "admin.logs.noLogsFiltered": "Nessun log corrisponde ai filtri",
    "admin.logs.filterAll": "Tutti",
    "admin.logs.totals": "{{count}} SDS",
    "admin.logs.totalsFiltered": "{{count}} visualizzati in questa pagina ({{total}} totali)",
    "admin.logs.localeSettings": "Impostazioni export e internazionali",

    "audit.export": "Esporta",
    "audit.export.modificheStatus": "Modifiche Stato",
    "audit.export.modificheOps": "Modifiche operazioni",
    "audit.export.modificheFilename": "Modifiche Filename",
    "audit.table.status": "Stato",
    "audit.table.lastUser": "Utente ultima operazione",
    "audit.table.timestampLastOp": "Data/Ora ultima operazione",
    "audit.table.filename": "Filename",
    "audit.table.revisionDate": "Data revisione",
    "audit.status.created": "Creato",
    "audit.status.parsing": "In elaborazione",
    "audit.status.validated": "Validato",
    "audit.status.history": "Archivio",
    "audit.status.deleted": "Eliminato",
    "audit.subtitle": "Registro immutabile delle operazioni sulle schede di sicurezza, a supporto degli audit e in linea con i requisiti di tracciabilità e controllo documentale.",
    "audit.premium.title": "Servizio Premium",
    "audit.premium.description": "Il servizio Audit è un servizio premium. Estendi l'abbonamento per abilitarlo.",
    "audit.localeSettings": "Impostazioni export e internazionali",
    "audit.downloadJson": "Scarica JSON",
    "audit.json.document_id": "ID documento",
    "audit.json.filename": "Nome del file",
    "audit.json.status": "Stato",
    "audit.json.timestamp": "Data/Ora",
    "audit.json.timestamp_formatted": "Data/Ora formattata",
    "audit.json.user_full_name": "Nome completo utente",
    "audit.json.user_email": "Email utente",
    "audit.json.ip_address": "IP",
    "audit.json.changes_per_field": "Modifiche per campo",
    "audit.json.field": "Campo",
    "audit.json.before": "Prima",
    "audit.json.after": "Dopo",
    "audit.json.changes": "Modifiche",

    "localeExportSettings.title": "Impostazioni export e internazionali",
    "localeExportSettings.csvSection": "CSV",
    "localeExportSettings.csvListSeparator": "Separatore colonne CSV",
    "localeExportSettings.dateTimeSection": "Data e ora",
    "localeExportSettings.dateFormat": "Formato data",
    "localeExportSettings.dateSeparator": "Separatore data",
    "localeExportSettings.timeFormat": "Formato ora (24 o 12)",
    "localeExportSettings.timeSeparator": "Separatore ora",
    "localeExportSettings.numbersSection": "Numeri",
    "localeExportSettings.decimalSeparator": "Separatore decimali",
    "localeExportSettings.thousandsSeparator": "Separatore migliaia",
    "localeExportSettings.decimalPlaces": "Cifre decimali",
    "localeExportSettings.loadError": "Impossibile caricare le impostazioni",
    "localeExportSettings.saveError": "Impossibile salvare le impostazioni",

    // UI elements
    Search: "Cerca",
    Confirm: "Conferma",
    "common.save": "Salva",
    "common.cancel": "Annulla",
    "support.title": "Contatta il Supporto",
    "support.description": "Hai bisogno di aiuto? Inviaci un messaggio e risponderemo entro 24 ore.",
    "support.type.label": "Tipo di Richiesta",
    "support.type.help": "Aiuto",
    "support.type.info": "Informazioni",
    "support.type.other": "Altro",
    "support.subject": "Oggetto",
    "support.message": "Messaggio",
    "support.send": "Invia",
    "support.request.sent": "Richiesta inviata con successo!",
    "support.response.time": "Risponderemo entro 24 ore.",

    // Common UI strings
    "common.copied": "Copiato negli appunti",
    "common.noData": "Nessun dato trovato",
    "common.error.generic": "Si è verificato un errore imprevisto",
    "common.errorBoundary": "Qualcosa è andato storto",
    "common.error.network": "Errore di rete. Controlla la connessione.",
    "common.error.server": "Errore del server. Riprova più tardi.",
    "common.loading": "Caricamento...",
    "common.required": "Questo campo è obbligatorio",
    "common.optional": "Opzionale",

    // Form validation
    "validation.firstName.required": "Nome obbligatorio",
    "validation.lastName.required": "Cognome obbligatorio",
    "validation.phone.required": "Numero di telefono obbligatorio",
    "validation.phone.invalid": "Numero di telefono non valido",
    "validation.countryCode.required": "Prefisso internazionale obbligatorio",

    // Signup page
    "signup.title": "Registrazione",
    "signup.activateAccount": "Attiva Account",
    "signup.activating": "Attivazione in corso...",
    "signup.signingUp": "Registrazione in corso...",
    "signup.accountCreated": "Account Creato con Successo!",
    "signup.enterCode": "Inserisci il codice di attivazione a 6 cifre inviato alla tua email.",
    "signup.activationSuccess": "Account Attivato con Successo!",
    "signup.loggingIn": "Accesso automatico in corso...",
    "signup.resendCode": "Reinvia Codice di Attivazione",
    "signup.backToSignup": "Torna alla registrazione",
    "signup.alreadyHaveAccount": "Hai già un account?",
    "signup.or": "OPPURE",
    "signup.passwordHint": "La password deve contenere almeno 8 caratteri, incluse lettere maiuscole, minuscole, numeri e caratteri speciali.",
    "signup.acceptTerms": "Accetto i",
    "signup.termsAndConditions": "Termini e Condizioni",
    "signup.and": "e la",
    "signup.privacyPolicy": "Privacy Policy",
    "signup.checkEmail": "Controlla la tua email per le istruzioni di attivazione.",
    "signup.resendActivation": "Reinvia Email di Attivazione",
    "signup.goToLogin": "Vai al Login",
    "signup.resendDialog.title": "Reinvia Codice di Attivazione",
    "signup.resendDialog.message": "Vuoi reinviare il codice di attivazione a {{email}}?",
    "signup.resendDialog.sending": "Invio in corso...",
    "signup.resendDialog.resend": "Reinvia",
    "signup.codeSent": "Codice di attivazione inviato. Controlla la tua casella di posta.",
    "signup.activationError": "Attivazione fallita. Riprova.",
    "signup.loginFailed": "Account attivato ma accesso fallito. Effettua il login manualmente.",
    "signup.invalidCode": "Inserisci un codice di attivazione valido a 6 cifre",

    // Analytics
    "analytics.title": "Analytics",
    "analytics.subtitle.company": "Panoramica del tuo inventario SDS — solo per amministratori",
    "analytics.subtitle.user": "Statistiche di {{name}}",
    "analytics.badge.mockData": "Dati di esempio — collegamento API in arrivo",
    "analytics.adminOnly": "Sezione riservata agli amministratori aziendali.",
    "analytics.filterUser.label": "FILTRA UTENTE",
    "sidebar.whats_new": "Novità v5",
    "analytics.filterUser.allCompany": "Tutta la company",
    "analytics.filterUser.tooltip": "{{name}} — {{role}} · {{count}} SDS",
    "analytics.kpi.total": "SDS in Inventario",
    "analytics.kpi.validated": "SDS Validate",
    "analytics.kpi.inProgress": "In Lavorazione",
    "analytics.kpi.svch": "Alert SVCH",
    "analytics.kpi.thisMonth": "Aggiunte questo mese",
    "analytics.kpi.validated.pct": "{{pct}}% validate",
    "analytics.kpi.validated.sub": "Archiviato o HP Finder",
    "analytics.kpi.inProgress.sub": "Parsing + editing",
    "analytics.kpi.svch.sub": "Sostanze di alta preoccupazione",
    "analytics.kpi.thisMonth.trend": "{{trend}} vs mese scorso",
    "analytics.ghs.title": "Pittogrammi GHS",
    "analytics.ghs.subtitle": "Distribuzione per classe di pericolo",
    "analytics.ghs.total": "totale",
    "analytics.hp.title": "Classi di Pericolo HP",
    "analytics.hp.subtitle": "Frasi H sezione 2 — occorrenze nel catalogo",
    "analytics.dpi.title": "DPI Richiesti (Sez. 8.2)",
    "analytics.dpi.subtitle": "% di SDS che richiedono ogni dispositivo",
    "analytics.clienti.title": "SDS per Cliente / Cantiere",
    "analytics.clienti.subtitle": "Distribuzione dell'inventario",
    "analytics.heatmap.title": "Attività Upload negli Ultimi 12 mesi",
    "analytics.heatmap.jan": "gen", "analytics.heatmap.feb": "feb", "analytics.heatmap.mar": "mar",
    "analytics.heatmap.apr": "apr", "analytics.heatmap.may": "mag", "analytics.heatmap.jun": "giu",
    "analytics.heatmap.jul": "lug", "analytics.heatmap.aug": "ago", "analytics.heatmap.sep": "set",
    "analytics.heatmap.oct": "ott", "analytics.heatmap.nov": "nov", "analytics.heatmap.dec": "dic",
    "analytics.alerts.title": "Conformità Normativa",
    "analytics.alerts.subtitle": "Alert attivi sull'inventario aziendale",
    "analytics.eer.title": "Codici EER",
    "analytics.eer.subtitle": "Rifiuti pericolosi vs non pericolosi",
    "analytics.eer.dangerous": "Pericolosi {{count}}",
    "analytics.eer.notDangerous": "Non pericolosi {{count}}",
    "analytics.produttori.title": "Top Produttori",
    "analytics.produttori.subtitle": "Fornitori con più SDS in catalogo",
    "analytics.alert.svch.label": "Sostanze SVCH",
    "analytics.alert.svch.desc": "Comunicazione ECHA richiesta se > 0,1%",
    "analytics.alert.allegato_xiv.label": "Allegato XIV REACH",
    "analytics.alert.allegato_xiv.desc": "Autorizzazione d'uso con scadenza",
    "analytics.alert.env_hazard.label": "Pericoloso per l'amb.",
    "analytics.alert.env_hazard.desc": "Gestione rifiuti speciali",
    "analytics.alert.cmr.label": "Sostanze CMR",
    "analytics.alert.cmr.desc": "Cancerogene, mutagene o tossiche per la riproduzione (CLP)",
    "analytics.alert.alert_conc.label": "Alert Concentrazione",
    "analytics.alert.alert_conc.desc": "Superamento soglie di concentrazione normative",
    "analytics.alert.seveso.label": "Soglia Seveso",
    "analytics.alert.seveso.desc": "Superamento soglie Direttiva 2012/18/UE",
    "analytics.alert.old_sds.label": "SDS > 3 anni",
    "analytics.alert.old_sds.desc": "Revisione obbligatoria ogni 3 anni per REACH",
    "analytics.export.button": "Esporta",
    "analytics.export.csv": "CSV",
    "analytics.export.excel": "Excel (.xlsx)",
    "analytics.export.pdf": "PDF",
    "analytics.loading": "Caricamento Analytics...",
    "analytics.error": "Errore nel caricamento dei dati",
    "analytics.noData": "Nessun dato disponibile",

    // Table
    "table.emptyState": "Nessun record disponibile",
    "table.noResults": "Nessun risultato per i filtri applicati",
    "table.noResultsHint": "Prova a modificare o rimuovere i filtri.",
    "table.search": "Cerca",
    "table.filter": "Filtra",
    "table.actions": "Azioni",
    "table.selected": "Selezione",
    "table.rowsPerPage": "Righe per pagina",
    "table.load-more": "Carica altri",
    "table.selectAll": "Seleziona tutto",
    "table.deselectAll": "Deseleziona tutto",
    "table.selectedPageRecords": "Hai selezionato {{count}} record di questa pagina.",
    "table.selectAllRecords": "Seleziona tutti i {{count}} record",
    "table.allRecordsSelected": "Hai selezionato tutti i {{count}} record.",

    // Audit
    "audit.title": "Log di audit",
    "audit.sidebarLabel": "Audit",
    "audit.filterAll": "Tutti",
    "audit.noRows": "Nessun record nel log.",
    "audit.noRowsFiltered": "Nessun record corrisponde ai filtri.",
    "audit.fetchError": "Impossibile caricare il log di audit.",
    "audit.error401": "Sessione scaduta. Esegui di nuovo l'accesso.",
    "audit.error403":
      "Accesso negato. Solo admin e auditor possono visualizzare il log.",
    "audit.error5xx": "Errore del server. Riprova più tardi.",
    "audit.table.modifiche": "Modifiche (JSON)",
    "audit.table.changeField": "Campo",
    "audit.table.changeBefore": "Prima",
    "audit.table.changeAfter": "Dopo",
    "audit.table.changeTimestamp": "Data e ora",
    "audit.table.changeUser": "Utente",
    "audit.table.changeIp": "IP",
    "audit.json.old_value": "Valore precedente",
    "audit.json.new_value": "Nuovo valore",

    "staff.consultants.title": "Consulenti in attesa di approvazione",
    "staff.consultants.subtitle": "Ogni approvazione crea automaticamente uno spazio personale con il piano Demo.",
    "staff.consultants.pendingCount": "{{count}} in attesa",
    "staff.consultants.accessDenied": "Accesso riservato allo staff HSE Genius.",
    "staff.consultants.empty": "Tutto in ordine — nessuna richiesta in attesa.",
    "staff.consultants.table.name": "Nome",
    "staff.consultants.table.email": "Email",
    "staff.consultants.table.phone": "Telefono",
    "staff.consultants.table.vat": "Partita IVA",
    "staff.consultants.table.actions": "Azioni",
    "staff.consultants.approve": "Approva",
    "staff.consultants.reject": "Rifiuta",
    "staff.consultants.rejectDialog.title": "Rifiuta richiesta di {{name}}",
    "staff.consultants.rejectDialog.text": "Il consulente riceverà una email con il motivo del rifiuto. L'account verrà rimosso.",
    "staff.consultants.rejectDialog.reasonLabel": "Motivo (opzionale)",
    "staff.consultants.rejectDialog.cancel": "Annulla",
    "staff.consultants.rejectDialog.confirm": "Conferma rifiuto",
    "staff.consultants.loadError": "Problema nel caricamento dei consulenti.",
    "staff.consultants.approveSuccess": "{{name}} approvato con successo.",
    "staff.consultants.approveError": "Approvazione non riuscita. Riprova.",
    "staff.consultants.rejectSuccess": "Richiesta di {{name}} rimossa.",
    "staff.consultants.rejectError": "Operazione non completata. Riprova.",

    // Onboarding
    "onboarding.title": "Benvenuto in HSE Genius",
    "onboarding.subtitle":
      "Per iniziare a usare la piattaforma, registra la tua azienda. Riceverai 5 crediti SDS per provare l'applicazione.",
    "onboarding.creating": "Creazione in corso...",
    "onboarding.errors.generic": "Impossibile creare l'azienda.",
    "onboarding.errors.unexpected": "Risposta imprevista. Riprova.",
    "onboarding.pending.title": "La tua azienda è in attesa di approvazione",
    "onboarding.pending.message":
      "Grazie per esserti registrato! Il nostro team sta esaminando la tua azienda. Riceverai un'email non appena verrà approvata e potrai accedere alla piattaforma.",

    // Admin
    "admin.welcomeMessage":
      "Benvenuto! Crea la tua azienda per continuare a usare la piattaforma.",
    "admin.company.deleteSuccess": "Utente rimosso con successo.",
    "admin.company.roleUpdated": "Ruolo aggiornato con successo",
    "admin.company.resendInviteError": "Invio dell'invito non riuscito.",
    "admin.invites.resendError": "Invio dell'invito non riuscito. Riprova.",
    "admin.invites.removeError": "Rimozione dell'invito non riuscita. Riprova.",

    "sds-counter.analyzed": "schede di sicurezza già analizzate",

    "auth.logout": "Esci",
    "common.next": "Avanti",
    "common.errorGeneric": "Si è verificato un errore. Riprova.",
    "registration.complete": "Completa la registrazione",

    // Toast di errore dal backend (vedi services/api/apiToastError.js)
    "api-error.generic":
      "Si è verificato un errore. Se il problema persiste, contatta il supporto.",
    "api-error.invalid-credentials": "Email o password non corretti.",
    "api-error.session-expired":
      "Sessione scaduta. Effettua nuovamente il login.",
    "api-error.already-taken": "Questo valore è già in uso.",
    "api-error.already-exists": "Questo valore esiste già.",
    "api-error.field-required": "Campo obbligatorio.",
    "api-error.field-blank": "Questo campo non può essere vuoto.",
    "api-error.invalid-email": "Inserisci un indirizzo email valido.",
    "api-error.invalid-integer": "Inserisci un numero valido.",
    "api-error.value-too-long": "Il valore inserito è troppo lungo.",
    "api-error.value-too-short": "Il valore inserito è troppo corto.",
    "api-error.invalid-selection": "Selezione non valida.",
    "api-error.invalid-number": "Valore numerico non valido.",
    "api-error.permission-denied":
      "Non hai i permessi per eseguire questa azione.",
    "api-error.not-found": "Elemento non trovato.",
    "api-error.password-too-short":
      "La password è troppo corta (minimo 8 caratteri).",
    "api-error.password-too-common":
      "La password è troppo comune. Sceglierne una più sicura.",
    "api-error.password-numeric": "La password non può contenere solo numeri.",
    "api-error.password-mismatch": "Le due password non corrispondono.",
    "api-error.throttled": "Troppe richieste. Riprova tra qualche momento.",
    "api-error.credit-limit": "Hai esaurito i crediti disponibili.",
    "api-error.request-limit": "Hai raggiunto il limite mensile di richieste.",
    "api-error.file-size": "Il file supera la dimensione massima consentita.",
    "api-error.file-type": "Tipo di file non supportato.",
  },
};

export default it;
